import React from 'react';
import { createRoot } from 'react-dom/client';
import "normalize.css";
import './index.css';
import './styles/typography.css';
import './styles/button.css';
import './styles/input.css';
import './styles/icons.css';
import App from './App';
import store from './store';
import { Provider } from "react-redux";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { BrowserRouter } from "react-router-dom";

createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Provider store={store}>
            <DndProvider backend={HTML5Backend}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </DndProvider>
        </Provider>
    </React.StrictMode>
);

// Real-user monitoring is fetched after the app renders, and only when it's configured.
if (process.env.REACT_APP_RUM_APP_MONITOR_ID) {
    import('./functions/rum').then(({ startRum }) => startRum());
}
